import { useState, useEffect } from 'react'
import { Container } from 'reactstrap'
import { COMPANY_DEALS_STATUS } from 'components/Company/constants'
import s from './Deals.scss'
import { Tabs } from 'components/ideal-core-ui'
import { DealsTable } from 'components/common/DealsTable'

const Deals = ({ deals, lostDeals, closedDeals, projectDeals, wonDeals }) => {
  const [companyDeals, setCompanyDeals] = useState(deals)

  useEffect(() => {
    setCompanyDeals(deals)
  }, [deals])

  const filterDeals = status => {
    switch (status) {
      case COMPANY_DEALS_STATUS.LOST:
        setCompanyDeals(lostDeals)
        break
      case COMPANY_DEALS_STATUS.PROJECT:
        setCompanyDeals(projectDeals)
        break
      case COMPANY_DEALS_STATUS.WON:
        setCompanyDeals(wonDeals)
        break
      case COMPANY_DEALS_STATUS.CLOSED:
        setCompanyDeals(closedDeals)
        break
      default:
        setCompanyDeals(deals)
    }
  }

  return (
    <Container>
      <section className={s.dealsContainer}>
        <Tabs
          activeTabKey="active"
          className={s.main}
          tabs={[
            {
              key: 'active',
              label: 'Active/Open',
              cb: () => filterDeals(COMPANY_DEALS_STATUS.ACTIVE),
              value: <DealsTable companyDeals={companyDeals} label="Active/Open Opportunities" />
            },
            {
              key: 'won',
              label: 'Won',
              cb: () => filterDeals(COMPANY_DEALS_STATUS.WON),
              value: <DealsTable companyDeals={companyDeals} label="Won Opportunities" />
            },
            {
              key: 'lost',
              label: 'Lost',
              cb: () => filterDeals(COMPANY_DEALS_STATUS.LOST),
              value: <DealsTable companyDeals={companyDeals} abel="Lost Opportunities" />
            },
            {
              key: 'project',
              label: 'Project',
              cb: () => filterDeals(COMPANY_DEALS_STATUS.PROJECT),
              value: <DealsTable companyDeals={companyDeals} label="Project Opportunities" />
            },
            {
              key: 'closed',
              label: 'Cancelled (not active)',
              cb: () => filterDeals(COMPANY_DEALS_STATUS.CLOSED),
              value: (
                <DealsTable
                  companyDeals={companyDeals}
                  label="Cancelled (not active) Opportunities"
                />
              )
            }
          ]}
        />
      </section>
    </Container>
  )
}

export default Deals
